import EditableClientGoal from './EditableClientGoal';

export default EditableClientGoal;
